import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/game/dialog/moaf-darkman.png'


const _withScopeId = n => (_pushScopeId("data-v-35e9a127"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]


export default /*#__PURE__*/_defineComponent({
  __name: 'DialogImage',
  props: {
  imageValue: String,
  firstImage: Boolean
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_Transition, {
      name: "fade2",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (__props.imageValue)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: require('@/assets/images/game/dialog/' + __props.imageValue + '.png'),
              alt: "Customer",
              class: "dialog-image",
              style: _normalizeStyle({ gridArea: __props.firstImage ? 'image1' : 'image2' })
            }, null, 12, _hoisted_1))
          : (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: _imports_0,
              alt: "You",
              class: "dialog-image",
              style: _normalizeStyle({ gridArea: __props.firstImage ? 'image1' : 'image2' })
            }, null, 4))
      ]),
      _: 1
    })
  ]))
}
}

})